import script from "./assignPlatform.vue?vue&type=script&setup=true&lang=js"
export * from "./assignPlatform.vue?vue&type=script&setup=true&lang=js"

import "./assignPlatform.vue?vue&type=style&index=0&id=40e23ab7&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40e23ab7"]])

export default __exports__